import { User } from "firebase/auth";

export const getUserId = (authenticatedUser: User | null | undefined): string => {
    return authenticatedUser?.phoneNumber || "default"
}
